import { lazyVue } from "@/utils";
export default [
  {
    path: "/menu",
    name: "menu",
    title: "菜单",
    component: lazyVue("menu"),
    meta: {
      title: '菜单',
      name: 'menu'
    }
  },
  {
    path: "/test",
    name: "test",
    title: "测试",
    component: lazyVue('test/index'),
    meta: {
      title: '测试',
      name: 'test',
      showBar: true,
      isKeepAlive: false,
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/menu/index.js